<section class="section-pd list-wrapper-style-2 pt-0 pb-0">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>Customizable Views: <br class="d-md-block d-none"/>Tailor Your Suggestion Alerts</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-left">
                    <div id="accordion_free" class="accordion">
                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="" aria-hidden="true" /></span>
                                    Individual Alert View
                                </a>
                            </div>
                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>Review word-level suggestions in a dedicated alert card with options to accept or dismiss. </p>
                                    <ul class="bt-list">
                                        <li>Review each suggestion in a separate card.</li>
                                        <li>Focus only on one alert at a time, avoiding information overload.</li>
                                        <li>Gain a better control and flexibility for every suggestion.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="similar sources" /></span>
                                    Sentence Alert View
                                </a>
                            </div>
                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>View all the suggestions for a sentence in a single card and accept or dismiss them in one-click. </p>
                                    <ul class="bt-list">
                                        <li>Save time by correcting full sentences in one go. </li>
                                        <li>Fewer cards to review reduces clutter. </li>
                                        <li>Accept or dismiss word-level suggestions within sentences</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                    <span><img src="../../../../assets/images/plagiarism-check/global.svg" alt="global" /></span>
                                    Bubble Alert View
                                </a>
                            </div>
                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>Expand your writing space and get suggestions and alerts right where you write.  </p>
                                    <ul class="bt-list">
                                        <li>Enjoy a more immersive and focused writing experience. </li>
                                        <li>Make corrections easily while you write. </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-right">
                    <div class="image video-feature" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                        <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="/assets/images/features/grammar-checker/individual-alerts.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                    <div class="image video-feature" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                        <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="/assets/images/features/grammar-checker/sentence-alerts.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                    <div class="image video-feature" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                        <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="/assets/images/features/grammar-checker/Bubble-view.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>